import { render, staticRenderFns } from "./redchirp-payment-methods.vue?vue&type=template&id=c9bcdff4&scoped=true&"
import script from "./redchirp-payment-methods.vue?vue&type=script&lang=js&"
export * from "./redchirp-payment-methods.vue?vue&type=script&lang=js&"
import style0 from "./redchirp-payment-methods.vue?vue&type=style&index=0&id=c9bcdff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bcdff4",
  null
  
)

export default component.exports